import React from 'react'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcInput,
  DcOverlaySlider,
  DcSwitch,
  DcText,
  PixelFactoryContext,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'

import { uploadPaymentSheet } from 'utils/api-routes.util'
import { Courier, IPixelFactory } from '../../../../../decl.d'
import FetchIcon from '../../../../utils/icons/fetch-icon'
import UploadIcon from '../../../../utils/icons/upload-icon'

const UploadPaymentInvoice = (props) => {
  const [show, setShow] = React.useState(false)
  const [error] = React.useState({
    error: '',
    field: '',
  })
  const {
    showPageLoader,
    hidePageLoader,
    showSuccess,
    showFailure,
    pixelConfirm,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const [fileUploadEnabled, setFileUploadEnabled] = React.useState(false)
  const [data, setData] = React.useState({
    invoice_name: '',
    invoice_reference: '',
    courier_id: '',
    company_id: 0,
    payment_gateway_id: '',
    weight_charges: '',
    fuel_charges: '',
    cash_handling_charges: '',
    gst: '',
    other_charges: '',
    arrears: '',
    invoice_amount: '',
    current_file: null,
  })
  React.useEffect(() => {
    setShow(props.show)
  }, [props])

  const handleSubmit = (e, force = false) => {
    if (!force) e.preventDefault()
    const formData = {
      ...data,
    }
    if (formData?.current_file) {
      delete formData.current_file
    }

    showPageLoader()
    uploadPaymentSheet(data.current_file, formData, force).subscribe((res) => {
      const response = res.response as { error: string }
      hidePageLoader()
      if (response.error) {
        if (
          response.error === 'duplicate_invoice_ref' ||
          response.error === 'duplicate_invoice_ref_with_different_file'
        ) {
          props.handleClose(false, response)
          pixelConfirm({
            title: 'Invoice reference already exists.',
            message: `Are you sure you want to overwrite invoice ${data.invoice_reference}?`,
            onConfirm: () => {
              showPageLoader()
              handleSubmit({}, true)
            },
          })
        } else {
          showFailure(response.error)
        }
      } else {
        showSuccess('Payment Invoice uploaded successfully')
        props.handleClose(false, response)
      }
    })
  }

  //FixMe: Use constants
  const disableInput = (): boolean => {
    if (!data.current_file) {
      if (
        data?.company_id == 1 ||
        data?.company_id == 8 ||
        data?.company_id == 6
      ) {
        return false
      }
      return true
    }
    return false
  }

  return (
    <DcOverlaySlider
      width="40%"
      title={'Upload a Payment Invoice'}
      onClose={() => {
        setShow(false)
        props.handleClose(true)
      }}
      isOpen={show}
    >
      <SectionContent>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcDropDown
                label={'Courier'}
                options={[
                  {
                    label: 'Select Courier',
                    value: '',
                  },
                  ...props.courierList.map((item: Courier) => {
                    return {
                      label: item.courier_name,
                      value: item.courier_id,
                    }
                  }),
                ]}
                value={data.courier_id}
                onChange={(e) => {
                  const companyId = props.courierList?.find(
                    (item) => item.courier_id == e.target.value,
                  )?.company_id
                  setData({
                    ...data,
                    courier_id: e.target.value,
                    company_id: companyId,
                  })
                }}
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            {data?.company_id == 1 || data?.company_id == 8
              ? fileUploadEnabled && (
                  <DcDiv
                    width="100%"
                    height="auto"
                    style={{
                      display: 'flex',

                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                      alignContent: 'center',
                      flexWrap: 'wrap',
                      gap: '10px',
                      flexGrow: 1,
                      flexShrink: 1,
                      flexBasis: '100%',
                    }}
                  >
                    <DcInput
                      label={'Courier Payment Invoice'}
                      error={
                        error.field === 'current_file' && error.error !== ''
                          ? error.error
                          : (undefined as string | undefined)
                      }
                      required
                      type={'file'}
                      style={{
                        padding: '8px 12px',
                      }}
                      name={'Select a Courier Payment Invoice'}
                      placeholder={'Select a Courier Payment Invoice'}
                      disabled={!data.courier_id}
                      onChange={(e) =>
                        setData({
                          ...data,
                          current_file: e.target.files[0],
                          invoice_name: e.target.files[0].name,
                        })
                      }
                    />
                  </DcDiv>
                )
              : data?.company_id != 6 && (
                  <DcDiv
                    width="100%"
                    height="auto"
                    style={{
                      display: 'flex',

                      flexDirection: 'column',
                      alignItems: 'flexStart',
                    }}
                  >
                    <DcInput
                      padding="8px 12px"
                      withLabel={true}
                      label={'Courier Payment Invoice'}
                      error={
                        error.field === 'current_file' && error.error !== ''
                          ? error.error
                          : null
                      }
                      style={{
                        padding: '8px 12px',
                      }}
                      required
                      type={'file'}
                      name={'Select a Courier Payment Invoice'}
                      placeholder={'Select a Courier Payment Invoice'}
                      disabled={!data.courier_id}
                      onChange={(e) =>
                        setData({
                          ...data,
                          current_file: e.target.files[0],
                          invoice_name: e.target.files[0].name,
                        })
                      }
                    />
                  </DcDiv>
                )}
            {data?.company_id == 1 || data?.company_id == 8 ? (
              <FormGroup
                flexEnd
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  width: '45%',
                }}
              >
                <DcSwitch
                  value={fileUploadEnabled}
                  onChange={(e) => {
                    setFileUploadEnabled(e.target.checked)
                  }}
                  label={'Upload File'}
                />
              </FormGroup>
            ) : null}
          </FormGroup>

          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcInput
                withLabel={true}
                label={'Invoice Name'}
                error={
                  error.field === 'invoice_name' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                type={'text'}
                name={'Invoice Name'}
                disabled={disableInput()}
                value={data.invoice_name}
                placeholder={'Invoice Name'}
                onChange={(e) =>
                  setData({
                    ...data,
                    invoice_name: e.target.value,
                  })
                }
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcInput
                withLabel={true}
                label={'Invoice/Payment Number'}
                error={
                  error.field === 'invoice_reference' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                type={'text'}
                name={'Invoice/Payment Number'}
                disabled={disableInput()}
                value={data.invoice_reference}
                placeholder={'Invoice/Payment Number'}
                onChange={(e) =>
                  setData({
                    ...data,
                    invoice_reference: e.target.value,
                  })
                }
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcInput
                withLabel={true}
                label={'Shipping/Weight Charges'}
                error={
                  error.field === 'weight_charges' && error.error !== ''
                    ? error.error
                    : null
                }
                type={'number'}
                name={'Shipping/Weight Charges'}
                disabled={disableInput()}
                value={data.weight_charges}
                placeholder={'Shipping/Weight Charges'}
                onChange={(e) =>
                  setData({
                    ...data,
                    weight_charges: e.target.value,
                  })
                }
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcInput
                withLabel={true}
                label={'Fuel Charges'}
                error={
                  error.field === 'fuel_charges' && error.error !== ''
                    ? error.error
                    : null
                }
                type={'number'}
                name={'Fuel Charges'}
                disabled={disableInput()}
                value={data.fuel_charges}
                placeholder={'Fuel Charges'}
                onChange={(e) =>
                  setData({
                    ...data,
                    fuel_charges: e.target.value,
                  })
                }
              />
            </DcDiv>

            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcInput
                withLabel={true}
                label={'Cash Handling Charges'}
                error={
                  error.field === 'cash_handling_charges' && error.error !== ''
                    ? error.error
                    : null
                }
                type={'number'}
                name={'Cash Handling Charges'}
                disabled={disableInput()}
                value={data.cash_handling_charges}
                placeholder={'Cash Handling Charges'}
                onChange={(e) =>
                  setData({
                    ...data,
                    cash_handling_charges: e.target.value,
                  })
                }
              />
            </DcDiv>

            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcInput
                withLabel={true}
                label={'GST'}
                error={
                  error.field === 'gst' && error.error !== ''
                    ? error.error
                    : null
                }
                type={'number'}
                name={'GST'}
                disabled={disableInput()}
                value={data.gst}
                placeholder={'GST'}
                onChange={(e) =>
                  setData({
                    ...data,
                    gst: e.target.value,
                  })
                }
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcInput
                withLabel={true}
                label={'Other Charges'}
                error={
                  error.field === 'other_charges' && error.error !== ''
                    ? error.error
                    : null
                }
                type={'number'}
                name={'Other Charges'}
                disabled={disableInput()}
                value={data.other_charges}
                placeholder={'Other Charges'}
                onChange={(e) =>
                  setData({
                    ...data,
                    other_charges: e.target.value,
                  })
                }
              />
            </DcDiv>

            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcInput
                withLabel={true}
                label={'Arrears'}
                error={
                  error.field === 'arrears' && error.error !== ''
                    ? error.error
                    : null
                }
                type={'number'}
                name={'Arrears'}
                disabled={disableInput()}
                value={data.arrears}
                placeholder={'Arrears'}
                onChange={(e) =>
                  setData({
                    ...data,
                    arrears: e.target.value,
                  })
                }
              />
            </DcDiv>

            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcInput
                withLabel={true}
                label={'Net Receivable Amount'}
                error={
                  error.field === 'invoice_amount' && error.error !== ''
                    ? error.error
                    : null
                }
                type={'number'}
                name={'Net Receivable Amount'}
                disabled={disableInput()}
                value={data.invoice_amount}
                placeholder={'Net Receivable Amount'}
                onChange={(e) =>
                  setData({
                    ...data,
                    invoice_amount: e.target.value,
                  })
                }
              />
            </DcDiv>
          </FormGroup>
          <FormGroup flexEnd>
            <DcButton
              variant="primary"
              disabled={!data.invoice_reference || !data.courier_id}
              type="submit"
              withIcon={true}
              size="sm"
            >
              {data?.company_id == 1 ||
              data?.company_id == 8 ||
              data?.company_id == 6 ? (
                <FetchIcon size={16} />
              ) : (
                <UploadIcon size={16} />
              )}
              <span>
                {data?.company_id == 1 ||
                data?.company_id == 8 ||
                data?.company_id == 6
                  ? 'Fetch'
                  : 'Upload'}
              </span>
            </DcButton>
          </FormGroup>
        </Form>
      </SectionContent>
    </DcOverlaySlider>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

export default UploadPaymentInvoice
